import React from 'react';
import { 
  FaFacebook, 
  FaInstagram, 
  FaLinkedinIn, 
  FaWhatsapp,
  FaEnvelope,
  FaGlobe,
  FaArrowLeft
} from "react-icons/fa";

const SocialMenu = ({ onClose }) => {
  const socialLinks = [
    {
      name: 'Site',
      url: 'https://www.hadritech.com.br',
      icon: <FaGlobe className="w-6 h-6" />,
      bgColor: 'bg-gradient-to-r from-blue-600 to-cyan-400',
    },
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/hadritech.consultoria/',
      icon: <FaFacebook className="w-6 h-6" />,
      bgColor: 'bg-[#1877F2]',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/hadritech.consultoria/',
      icon: <FaInstagram className="w-6 h-6" />,
      bgColor: 'bg-gradient-to-r from-[#F58529] via-[#DD2A7B] to-[#8134AF]',
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/company/hadritech-oficial/',
      icon: <FaLinkedinIn className="w-6 h-6" />,
      bgColor: 'bg-[#0A66C2]',
    },
    {
      name: 'WhatsApp',
      url: 'https://wa.me/5511954938127',
      icon: <FaWhatsapp className="w-6 h-6" />,
      bgColor: 'bg-[#25D366]',
    },
    {
      name: 'E-mail',
      url: 'mailto:contato@hadritech.com.br',
      icon: <FaEnvelope className="w-6 h-6" />,
      bgColor: 'bg-gray-700',
    },
  ];

  return (
    <div className="bg-white rounded-xl p-6 w-full max-w-md">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Nossas Redes</h2>
        <button 
          onClick={onClose}
          className="text-gray-500 hover:text-gray-700"
          aria-label="Fechar"
        >
          <FaArrowLeft className="w-6 h-6" />
        </button>
      </div>
      
      <div className="space-y-3">
        {socialLinks.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex items-center p-4 rounded-lg text-white ${link.bgColor} transition-all duration-300 hover:opacity-90`}
          >
            <span className="mr-3">{link.icon}</span>
            <span className="font-medium">{link.name}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialMenu;
